import { Card, Flexbox } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'

function StreetAnimalDetails({ clinicalCare }) {
  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">Situação do pet</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-clipboard-list" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Animal de rua</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {clinicalCare?.ofStreetAnimal ? 'Sim' : 'Não'}
          </Flexbox.Column>
        </Flexbox.Columns>
        {clinicalCare?.ofStreetAnimal && (
          <>
            <Flexbox.Columns className="mb-1">
              <Flexbox.Column>Declaração obrigatória confirmada</Flexbox.Column>
              <Flexbox.Column className="col-auto text-bold">
                {clinicalCare?.ofStreetAnimalConfirmed ? 'Sim' : 'Não'}
              </Flexbox.Column>
            </Flexbox.Columns>
            <div className="text-bold my-2">
              O animal deverá ser devolvido no mesmo endereço após o atendimento.
            </div>
          </>
        )}
      </Card.Body>
    </Card.Base>
  )
}

StreetAnimalDetails.propTypes = {
  clinicalCare: PropTypes.objectOf(Object).isRequired,
}

export default StreetAnimalDetails
